import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { docTypeError } from '@milkdown/exception';
import { baseKeymap } from 'prosemirror-commands';
import { inputRules as createInputRules } from 'prosemirror-inputrules';
import { keymap as createKeymap } from 'prosemirror-keymap';
import { DOMParser, Node } from 'prosemirror-model';
import { EditorState } from 'prosemirror-state';
import { createSlice } from '../context';
import { createTimer } from '../timing';
import { inputRulesCtx, InputRulesReady } from './input-rules';
import { keymapCtx, KeymapReady } from './keymap';
import { parserCtx, ParserReady } from './parser';
import { prosePluginsCtx } from './prose-plugin-factory';
import { schemaCtx } from './schema';
import { SerializerReady } from './serializer';
export const defaultValueCtx = createSlice('', 'defaultValue');
export const editorStateCtx = createSlice({}, 'editorState');
export const editorStateOptionsCtx = createSlice({}, 'stateOptions');
export const editorStateTimerCtx = createSlice([], 'editorStateTimer');
export const EditorStateReady = createTimer('EditorStateReady');
const getDoc = (defaultValue, parser, schema) => {
    if (typeof defaultValue === 'string') {
        return parser(defaultValue);
    }
    if (defaultValue.type === 'html') {
        return DOMParser.fromSchema(schema).parse(defaultValue.dom);
    }
    if (defaultValue.type === 'json') {
        return Node.fromJSON(schema, defaultValue.value);
    }
    throw docTypeError(defaultValue);
};
export const editorState = (pre) => {
    pre.inject(defaultValueCtx)
        .inject(editorStateCtx)
        .inject(editorStateOptionsCtx)
        .inject(editorStateTimerCtx, [KeymapReady, InputRulesReady, ParserReady, SerializerReady])
        .record(EditorStateReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(editorStateTimerCtx);
        const schema = ctx.get(schemaCtx);
        const parser = ctx.get(parserCtx);
        const rules = ctx.get(inputRulesCtx);
        const keymap = ctx.get(keymapCtx);
        const options = ctx.get(editorStateOptionsCtx);
        const prosePlugins = ctx.get(prosePluginsCtx);
        const defaultValue = ctx.get(defaultValueCtx);
        const doc = getDoc(defaultValue, parser, schema);
        const state = EditorState.create(Object.assign({ schema,
            doc, plugins: [...prosePlugins, ...keymap, createKeymap(baseKeymap), createInputRules({ rules })] }, options));
        ctx.set(editorStateCtx, state);
        ctx.done(EditorStateReady);
    });
};
//# sourceMappingURL=editor-state.js.map